import { useIsFeatureRolloutEnabled } from '@ms/yammer-experiments-context';

import type { UseUIFeatureCheck } from '../types';

export const useIsChatEnabled: UseUIFeatureCheck = () => useIsFeatureRolloutEnabled('TeamsChatButton');
